<template>
  <div class='response-personal atb-flex atb-flex-column'>
    <div class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native="getList('resetPage')" @submit.native.prevent>
          <el-form-item label="年份">
            <el-date-picker v-model="searchParam.year" type="year" format="yyyy 年" value-format="yyyy" placeholder="选择年份"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList('resetPage')">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="add" v-throttle @click="showAdd(addTypes.ADD)">新增</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="add" v-throttle @click="showAdd(addTypes.SUPPLY)">补填</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="add" v-throttle @click="showAdd(addTypes.UPDATE)">更新</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <vxe-table
          class='atb-table header-table edit-table'
          border='full'
          height='100%'
          auto-resize
          resizable
          :data="tableData"
          ref="table"
          :edit-config="{trigger: 'manual', mode: 'row'}"
          :merge-cells="mergeCells"
          @cell-dblclick="dbClickGoDetail"
          @cell-click="expandRow"
        >
          <vxe-table-column field="rowNumber" width="50" title="NO."></vxe-table-column>
          <vxe-table-column field="wkNo" title="工号" width="100"></vxe-table-column>
          <vxe-table-column field="wkName" title="姓名" width="100"></vxe-table-column>
          <vxe-table-column field="year" title="年份" width="100"></vxe-table-column>
          <vxe-table-column field="department" title="部门" width="360" ></vxe-table-column>
          <vxe-table-column field="commitDate" title="提交时间" width="100">
            <template #edit="{ row }">
              <el-date-picker v-model="row.commitDate" type="date" value-format="yyyy/MM/dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{row.commitDate ? new Date(row.commitDate).toLocaleDateString() : ''}}</template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" width="120">
            <template #default="{ row }">
              <el-tag v-if="row.status === 10" type="close" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else-if="row.status === -1" type="unstart" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else type="complete" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column field="approveReason" title="审批意见" min-width="150">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.approveReason || '无' }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" class-name='operation' width="100">
            <template #default="{row}">
              <el-tooltip class='item' effect='dark' content='编辑' placement="bottom" v-if="row.status != -1">
                <i class='icon-editor' @click.stop='goDetail({row: row})'></i>
              </el-tooltip>
              <el-tooltip class='item' effect='dark' content='删除' placement="bottom" v-if="row.status != -1">
                <i class='icon-close delete' @click.stop='deleteTip(row)'></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
       <div class='page-con atb-flex atb-flex-justify-end'>
          <vxe-pager
            background
            :current-page.sync="page.pageIndex"
            :page-size.sync="page.pageSize"
            :total="total"
            height="100%"
            @page-change="handlePageChange"
            :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
          >
          </vxe-pager>
        </div>
    </div>
    
    <el-dialog title="提示" :visible.sync="showDelTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要删除吗</h2>
        <p>此操作会删除对应的工作项</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="del">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showDelTip = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="addTtitle" :visible.sync="isShowAdd" v-if="isShowAdd" width="350px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div>
        <el-form :model="addForm" :rules="rules" ref="form" label-width='60px' class="atb-input" label-position="right">
          <el-form-item label="年份" prop="year">
            <el-date-picker
              v-model="addForm.year"
              type="year"
              format="yyyy 年"
              value-format="yyyy"
              placeholder="选择年份"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="createNew">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="isShowAdd = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils'
  import _ from 'lodash'
  export default {
    name: "ResponseWork",
    data() {
      return {
        currWkNo: '',

        searchParam: {
          year: undefined,
        },
     
        page: {
          pageIndex: 1,
          pageSize: 10
        },
        total: 0,
        tableData: [],
        statusMap: {},
        showDelTip: false,
        row:{},

        addForm: {
          year: undefined,
        },
        isShowAdd: false,

        rules: {
          year: [{ required: true, message: '"年份"为必填项', trigger: 'change' }],
        },

        addType: 0,
        addTypes: {
          ADD: 0,
          SUPPLY: 1,
          UPDATE: 2,
        },
        mergeCells: [],
      }
    },
    computed: {
      addTtitle() {
        const titles = ['新增', '补填', '更新'];
        return titles[this.addType];
      },
    },
    created() {
      const userInfo = sessionStorage.getItem('userInfo');
      this.currWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';
      this.getStatus();
    },
    mounted() {
      this.getList();
    },
    methods: {
      getStatus() {
        return this.$ajax.get(this.$api.common.getDict, { ItemType: 'ResponseStatus' }).then((res) => {
          let rows = res.data.rows || [];
          this.statusMap = {};
          rows.forEach(item => {
            this.statusMap[item.itemValue] = item.itemDesc;
          })
        });
      },
      getList(resetPage) {
        if(resetPage){
          this.page.pageIndex = 1;
        }
        let param = Object.assign({ year: this.searchParam.year || undefined }, this.page)
        this.$ajax.post(this.$api.responsWork.personal.list, param).then((res) => {
          let rows = res.data.data || [];
          rows.forEach(val => {
            val.expandRowFlag = false;
          });

          this.handleTableData(rows);
          this.total = res.data.total;
        });
      },
      handleTableData(rows) {
        let tableData = [];
        let mergeCells = [];
        let rowIndex = 0;
        rows.forEach((item, index) => {
          const childRows = item.responseInfos || [];
          childRows.forEach(childItem => {
            tableData.push({...childItem, rowNumber: (this.page.pageIndex - 1) * this.page.pageSize + index + 1});
          })
          const length = childRows.length;
          mergeCells.push(
            ...[
              {row: rowIndex, col: 0, rowspan: length, colspan: 1},
              {row: rowIndex, col: 1, rowspan: length, colspan: 1},
              {row: rowIndex, col: 2, rowspan: length, colspan: 1},
              {row: rowIndex, col: 3, rowspan: length, colspan: 1},
            ]
          )
          rowIndex += childRows.length;

        });
        this.tableData = tableData;
        this.mergeCells = mergeCells;
      },
      // 通用行合并函数（将相同多列数据合并为一行）
      mergeRowMethod ({ row, _rowIndex, column, visibleData }) {
        console.log(column.field);
        
        const fields = ['wkName', 'wkNo', 'year' ]
        const cellValue = row[column.field]
        if (cellValue && fields.includes(column.field)) {
          const prevRow = visibleData[_rowIndex - 1]
          let nextRow = visibleData[_rowIndex + 1]
          if (prevRow && prevRow[column.field] === cellValue) {
            return { rowspan: 0, colspan: 0 }
          } else {
            let countRowspan = 1
            while (nextRow && nextRow[column.field] === cellValue) {
              nextRow = visibleData[++countRowspan + _rowIndex]
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 }
            }
          }
        }
      },
      showAdd(type) {
        this.isShowAdd = true;
        this.addType = type;
      },
      async createNew() {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            let msg = '新增成功';
            let api = this.$api.responsWork.personal.add;
            if (this.addType === this.addTypes.SUPPLY) {
              api = this.$api.responsWork.personal.supply;
              msg = '补填成功';
            } else if (this.addType === this.addTypes.UPDATE) {
              msg = '更新成功';
              api = this.$api.responsWork.personal.update;
            }
            this.$ajax.get(api, {
              year: this.addForm.year ? parseInt(this.addForm.year) : undefined,
            }).then((res) => {
              this.isShowAdd = false;
              this.getList();
              this.$message.success(res.data || msg);
            });
          }
        })
      },
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      expandRow({ row, rowIndex }) {
        this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
        this.$refs.table.updateData(this.tableData);
      },

      deleteTip(row) {
        this.showDelTip = true;
        this.row = row;
      },
      del() {
        this.$ajax.get(this.$api.responsWork.personal.del + '?id=' + this.row.id).then(() => {
          this.$message.success('删除成功');
          this.getList();
        }).finally(()=>{
          this.showDelTip = false;
        });
      },

      handlePageChange({currentPage}) {
        this.page.pageIndex = currentPage;
        this.getList();
      },
      // 双击跳转详情页，合并行不能双击跳转
      dbClickGoDetail({row, columnIndex}) {
        if (columnIndex < 4) return false;
        if (row.status == -1) return false;
        this.goDetail({row});
      },
      goDetail({row}) {
        this.$router.push({
          path: '/response/personal/detail',
          query:{
            id: row.id,
            editStatus: 'edit'
          }
        });
      }
    },
  }
</script>
<style scoped lang='scss'>
  .response-personal {
    height: 100%;
    .atb-content-bg {
      flex: 1;
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    ::v-deep .el-input-group__append {
      padding: 0 5px;
    }
  }
  .footer {
    text-align: right;
    margin-top: 20px;
    .select-all-program {
      margin-right: 20px;
    }
  }

</style>